export default document.getElementsByTagName("html")[0].dataset.railsEnv;
